import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import styles from '../../PackagesRoomsAmenities.module.scss';

type Props = {
  id: string | number;
  children: (
    dragHandleProps: {
      handleRef: (node: HTMLElement | null) => void;
    } & React.HTMLAttributes<HTMLElement>
  ) => React.ReactNode;
};

export const SortableItem = ({ id, children }: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: String(id) });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
        position: 'relative',
        zIndex: isDragging ? 1 : undefined,
      }}
      className={styles.sortableItem}
    >
      {children({
        ...attributes,
        ...listeners,
        handleRef: (node) => {
          setActivatorNodeRef(node);
        },
      })}
    </div>
  );
};
